import { FC } from 'react';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { PlusIcon } from 'icons/plus';
import CloseIcon from '@mui/icons-material/Close';
import s from './customization-configuration-item.module.scss';

type Props = {
  name: string;
  is_shown: boolean;
  disableDeleteAction: boolean;
  onClickIcon?: () => void;
};

const CustomizationItem: FC<Props> = ({ name, is_shown, disableDeleteAction = false, onClickIcon }) => {
  const handleIconClick = (e: React.MouseEvent<SVGSVGElement>) => {
    e.stopPropagation();
    onClickIcon?.();
  };
  return (
    <div className={s.container}>
      <DragIndicatorIcon
        className={`${s.drag_area} ${!disableDeleteAction ? 'handle-area' : ''}`}
        style={disableDeleteAction ? { opacity: 0.5, pointerEvents: 'none' } : {}}
      />
      <span>{name || ''}</span>

      {is_shown && (
        <span className={s.action_button_container}>
          <CloseIcon
            onClick={handleIconClick}
            className={s.action_button}
            style={{
              opacity: disableDeleteAction ? 0.5 : 1,
              cursor: disableDeleteAction ? 'pointer' : 'pointer',
              pointerEvents: disableDeleteAction ? 'none' : 'all',
            }}
          />
        </span>
      )}

      {!is_shown && (
        <span className={s.action_button_container}>
          <PlusIcon color="#0851FE" onClick={handleIconClick} className={s.action_button} strokeWidth={1.1} />
        </span>
      )}
    </div>
  );
};

export default CustomizationItem;
